export const HOST_API = import.meta.env.VITE_HOST_API;
export const DOMAIN_NAME = import.meta.env.VITE_DOMAIN_NAME;
export const DEVELOPMENT = import.meta.env.VITE_DEVELOPMENT === 'true';
export const IS_LOCALHOST = import.meta.env.VITE_IS_LOCALHOST === 'true';
export const STORAGE_HOST_API_MINIO = import.meta.env.VITE_STORAGE_HOST_API_MINIO;
export const STORAGE_HOST_API_R2 = import.meta.env.VITE_STORAGE_HOST_API_R2;
export const STORAGE_R2_PREFIX = 'cf_';
export const SHARED_BUCKET_NAME = import.meta.env.VITE_SHARED_BUCKET_NAME;
export const APP_BUILD_VERSION = import.meta.env.VITE_APP_BUILD_VERSION;
export const SUPPORT_CONTACT_URL = 'https://t.me/menta_admin';
export const POSTHOG_KEY = import.meta.env.VITE_POSTHOG_KEY;
export const POSTHOG_HOST = import.meta.env.VITE_POSTHOG_HOST;
export const CENTRIFUGO_WS_URL = import.meta.env.VITE_CENTRIFUGO_WS_URL;
export const SENTRY_DSN = import.meta.env.VITE_SENTRY_DSN;
